import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { OnboardProviderBody } from "@shared-kernel/application/ports/shared/shared-repository";

export const onboardProvider = createAsyncThunk<void, OnboardProviderBody, { extra: Partial<Dependencies> }>(
  "users/onboardProvider",
  async (body, { extra: { sharedRepository } }) => {
    return sharedRepository!.onboardProvider(body);
  },
);
